import React from "react";

function ScrollTop(props) {

        return <a href={props.link} className="scrollTop">
            <div className="scrollTop__Img"> </div>
        </a>
}

export default ScrollTop;